import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './en.json';
import sv from './sv.json';

export const SUPPORTED_LANGS = ['en', 'sv'];
export const DEFAULT_LANG = 'en';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      sv: { translation: sv },
    },
    fallbackLng: DEFAULT_LANG,
    supportedLngs: SUPPORTED_LANGS,
    interpolation: { escapeValue: false },
    detection: {
      order: ['path', 'localStorage', 'navigator'],
      lookupFromPathIndex: 0,
      lookupLocalStorage: 'scrappy_lang',
      caches: ['localStorage'],
    },
    react: {
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p', 'span'],
    },
  });

// Detect Swedish from navigator language (sv, sv-SE, etc.)
export const detectInitialLang = () => {
  if (typeof window === 'undefined') return DEFAULT_LANG;
  const stored = window.localStorage.getItem('scrappy_lang');
  if (stored && SUPPORTED_LANGS.includes(stored)) return stored;
  const nav = (navigator.language || navigator.userLanguage || '').toLowerCase();
  if (nav.startsWith('sv')) return 'sv';
  return DEFAULT_LANG;
};

export default i18n;
